import NewProjectLayout from "pages/project/NewProjectLayout";
import { ProjectTypes } from "service/projects";

const WellPlannerCreateProject = () => {
  return (
    <NewProjectLayout
      input={{
        project_type: ProjectTypes[2].value,
        project_name: "",
        comment: "",
        redirect: "/project_summary/",
      }}
    />
  );
};
export default WellPlannerCreateProject;